module.exports = __webpack_public_path__ + "img/cases-part1-4.50853b5d.png";